// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__18Dm8","inner":"Form_inner__1ZYM4","range":"Form_range__3fYfa","name":"Form_name__HOIQO","actions":"Form_actions__eN2mN"};